import ListItem from "@mui/material/ListItem";
import { styled } from "@mui/system";

export const MainListItem = styled(ListItem)`
  &.MuiListItem-button:hover {
    color: #000000 !important;
    background: rgba(0, 0, 0, 0.04) !important;
  }
`;
